import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationCalc'
})
export class DurationCalcPipe implements PipeTransform {

  transform(duration: any, ...args: any[]): unknown {
    if (args[0] == "h") {
      if (duration > 24) {
        return duration / 24 + " Days"
      } else {
        return duration + " Hours"
      }
    }
  }

}
